import { Action, createReducer, on } from '@ngrx/store';

import { AuthActions } from '../actions';
import { AuthState } from '../state';

export const initialState = {};

const reducer = createReducer(
    initialState,
    on(AuthActions.updateSessionUser, (state: AuthState, { sessionUser }) => ({ ...state, sessionUser }))
);

export function authReducer(state: AuthState, action: Action): AuthState {
    return reducer(state, action);
}
